// @flow

// @todo comment nationality in if FBO-3323 is done
// import {toUpper} from 'lodash';

// import {config} from 'config';

export type TravelerData = {
  id: number,
  title: string,
  firstName: string,
  lastName: string,
  birthday: string,
  // nationality?: string,
};

export type TravelerForm = {
  data: TravelerData,
  errors?: {[field: string]: string},
  isValid: boolean,
};

export const emptyForm: TravelerForm = {
  data: {
    id: 0,
    title: '',
    firstName: '',
    lastName: '',
    birthday: '',
    // nationality: '',
  },
  isValid: false,
};
